// extracted by mini-css-extract-plugin
module.exports = {"Tips":"Tips_Tips__t0xvD"};